module.exports = __webpack_public_path__ + "img/home9.96bf1ad2.svg";